var _defs, _use;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAttachment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "attachment-a",
    d: "M4.68779834,20.2994311 C2.43760892,18.0333156 2.4371922,14.3650733 4.68779834,12.0985763 L13.4166633,3.30797074 C15.1485254,1.56400975 17.9662912,1.56400975 19.6980775,3.30797074 C21.4337658,5.0559753 21.4341825,7.88552025 19.6980775,9.63386814 L12.3481103,17.0358128 C11.1296508,18.2628835 9.14699739,18.2628454 7.92857571,17.0358509 C6.7074264,15.8060717 6.7069718,13.8150334 7.92857571,12.5849109 L14.1533913,6.3160431 C14.335234,6.13293807 14.6300086,6.13293807 14.8118134,6.3160431 L15.4700081,6.97895961 C15.6517371,7.1620265 15.6517371,7.45877109 15.4700081,7.64179983 L9.24504089,13.9107821 C8.75141381,14.4077978 8.7511865,15.2126589 9.24504089,15.7099035 C9.73753147,16.2058892 10.539003,16.2059655 11.0316073,15.7098653 L18.3815365,8.30799697 C19.3896647,7.29279401 19.3899299,5.6493882 18.3815744,4.6339182 C17.3756435,3.62088961 15.7390216,3.62096591 14.7331285,4.6339182 L6.0043014,13.4244856 C4.48170998,14.9577614 4.48133114,17.4399027 6.00426352,18.9735981 C7.52821876,20.5083616 9.99548287,20.508209 11.5191729,18.9724918 C13.6161599,16.8588875 17.0206336,13.4287962 19.1184161,11.315993 C19.300183,11.132888 19.5948818,11.1330024 19.7766866,11.3161456 L20.4348813,11.9790621 C20.6166482,12.162129 20.6167997,12.458721 20.4350328,12.6417498 C18.3374018,14.7544385 14.9331176,18.1843772 12.8362064,20.2978289 C10.5849183,22.5670343 6.93950311,22.5670725 4.68779834,20.2994311 Z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#40B3DB",
    xlinkHref: "#attachment-a"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default __webpack_public_path__ + "static/media/attachment.7ad09e33.svg";
export { ForwardRef as ReactComponent };